import { trackSimpleEvent } from "../../shared/utils/reduxBeacon";

const gaEventsMap = {
  ...trackSimpleEvent("order/getNewOrders"),
};

export default gaEventsMap;
